<template>
  <div class="main">
    <div class="header">
      <div class="nav">
        <div class="left">
          <img
            v-if="$store.state.common.bureau.siteShowType == '1'"
            src="/home/logo.png"
          />
          <img
            v-if="$store.state.common.bureau.siteShowType == '2'"
            :src="$store.state.common.bureau.siteLogoUrl"
          />
          <span v-if="bureauData">{{
            bureauData.siteName ||
            bureauData.bureauName.replace(/教育局/g, '') + '站'
          }}</span>
        </div>
        <div class="entry">
          <span class="state">家长端手机App下载</span>
          <a href="javascript:;" class="app-code android-app">
            安卓版
            <img src="/home/qrcode.png" alt /> </a
          >&nbsp;|
          <a href="javascript:;" class="app-code ios-app">
            IOS版
            <img src="/home/qrcode.png" alt />
          </a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="wrap">
          <div class="slogan"></div>
          <div class="mid">
            <div class="main-entry">
              <a href="javascript:;" class="synthesis-login">
                <span class="title" @click="goUrl('login')">
                  <i class="synthesis"></i>综合管理平台
                </span>
                <s></s>
              </a>
              <a href="javascript:;" class="org-login">
                <span class="title"> <i class="org"></i>开放平台</span>
                <span class="org-entry" @click="goUrl('institutionRegister')"
                  >申请入驻</span
                >
                <span class="inerval-line"></span>
                <span
                  class="org-entry"
                  @click="goUrl('login', 'provider_login')"
                  >自助管理</span
                >
                <s></s>
              </a>

              <a href="javascript:;" class="school-login">
                <span class="title" @click="goUrl('login')">
                  <i class="school"></i>校园管理平台
                </span>
                <span class="org-entry" @click="goUrl('login', 'school_login')"
                  >校园管理</span
                >
                <span class="inerval-line"></span>
                <span class="org-entry" @click="goUrl('centerManageLogin')"
                  >中心校管理</span
                >
                <s></s>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="back">
        <div class="items">
          <div class="item item-bg-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import bureau from '../../api/bureau'
export default {
  name: 'home',
  data() {
    return {
      bureauData: null,
    }
  },
  methods: {
    goUrl(url, mode) {
      if (url == 'institutionRegister') {
        this.$store.commit('CLEARLOGIN')
        this.$router.replace(url)
        return
      }
      // this.$router.push(url)
      this.$router.push({
        name: url,
        params: { mode: mode },
      })
    },
  },
  created() {
    bureau.getBureau().then((res) => {
      this.bureauData = res
    })
    
    this.$store.commit('register/emptyRegister', {
      institutionType: 2,
      status: 0,
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.header {
  position: fixed;
  width: 100%;
  top: 20px;
  left: 0px;
  z-index: 999;
}

.nav {
  width: calc(100% - 300px);
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
}

.left {
  float: left;
  display: block;
  img {
    height: 30px;
  }
  span {
    vertical-align: middle;
    color: #60b59a;
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
    letter-spacing: 1.2px;
    padding: 0px 4px;
    line-height: 20px;
    border-radius: 4px;
    border: 1px solid #60b59a;
    position: relative;
    top: 2px;
  }
}

.entry {
  float: right;
  color: #6eb298;
}

.entry .state {
  font-size: 12px;
  color: #6eb298;
}

.entry a {
  font-size: 12px;
  color: #6eb298;
  margin: 0 5px;
}

.entry a:hover {
  color: #00bbee;
}

.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.content {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.wrap {
  position: absolute;
  left: 0;
  top: 20%;
  width: 100%;
  text-align: center;
  z-index: 2;
}

.slogan {
  width: 600px;
  height: 200px;
  background: url(/home/txt-01.png) no-repeat 0 0;
  display: inline-block;
  background-size: 600px;
}

.mid {
  width: 100%;
}

.main-entry {
  width: 550px;
  height: 50px;
  margin: 15px auto 0;
}

.main-entry a {
  display: block;
  text-decoration: none;
  float: left;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;
  letter-spacing: 1px;
  height: 50px;
  width: 170px;
  color: #ffffff;
  line-height: 50px;
  position: relative;
  overflow: hidden;
}

.main-entry a .title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  padding-left: 18px;
}

.main-entry a .title i {
  position: absolute;
  left: 20px;
  top: 14px;
  display: block;
  width: 24px;
  height: 24px;
  background-size: 24px;
  background-repeat: no-repeat;
}

.main-entry a .title .synthesis {
  background-image: url(/home/icon-01.png);
}

.main-entry a .title .org {
  background-image: url(/home/icon-02.png);
}

.main-entry a .title .school {
  background-image: url(/home/icon-03.png);
}

.main-entry s {
  background-color: #6eb298;
  opacity: 0.9;
  display: block;
  border-radius: 8px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
}

.main-entry a:hover s {
  background-color: #6eb298;
  opacity: 1;
}

a.school-login,
a.org-login {
  margin-left: 20px;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;

  .org-entry {
    display: none;
    z-index: 2;
    position: relative;
    height: 50px;
  }
  .inerval-line {
    display: none;
    width: 150px;
    margin: 0 auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    height: 0;
    z-index: 2;
  }
}

a.org-login:hover {
  height: 100px;
  margin-top: -25px;
}

a.org-login:hover .title {
  display: none;
}

a.org-login:hover .org-entry,
a.org-login:hover .inerval-line {
  display: block;
}

a.school-login:hover {
  height: 100px;
  margin-top: -25px;
  .title {
    display: none;
  }
}

a.school-login:hover .org-entry,
a.school-login:hover .inerval-line {
  display: block;
}

/*slide*/
.items,
.item {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.item-bg-1 {
  background-image: url(/home/bg-01.png) !important;
}

.back {
  bottom: 70px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.items {
  overflow: visible;
}

.item {
  background: #fff none no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

/*by yangjie*/
.app-code {
  display: inline-block;
  position: relative !important;
}

.app-code > img {
  display: none !important;
}

.android-app:hover > img {
  display: block !important;
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
  width: 160px;
}

.ios-app:hover > img {
  display: block !important;
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
  width: 160px;
}
</style>
